import { render, staticRenderFns } from "./joinGift.vue?vue&type=template&id=7080c30f&scoped=true"
import script from "./joinGift.vue?vue&type=script&lang=js"
export * from "./joinGift.vue?vue&type=script&lang=js"
import style0 from "./joinGift.vue?vue&type=style&index=0&id=7080c30f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7080c30f",
  null
  
)

export default component.exports